// extracted by mini-css-extract-plugin
export var buttons = "Footer-module--buttons--dcf78";
export var grid = "Footer-module--grid--36891";
export var image = "Footer-module--image--68840";
export var inner = "Footer-module--inner--13b07";
export var inner2 = "Footer-module--inner2--8fb8c";
export var legal = "Footer-module--legal--62160";
export var links = "Footer-module--links--e9149";
export var logo = "Footer-module--logo--a9062";
export var newsletter = "Footer-module--newsletter--9ddd4";
export var wrapper = "Footer-module--wrapper--ad79e";